module.exports = __webpack_public_path__ + "img/linkedin.77147cf5.svg";